export const HEADER_PERMISSIONS = {
  PLUS_BUTTON: 'header.plus-button',
  COMPANIES_SELECTOR: 'header.companies-selector',
};

export const MAINMENU_PERMISSIONS = {
  COMPANY: 'mainmenu.company',
  CAMPAIGN: 'mainmenu.campaign',
  JOB: 'mainmenu.job',
  CANDIDATES: 'mainmenu.candidates',
};

export const ACCOUNT_PERMISSIONS = {
  CREATE: 'account.create',
  EDIT: 'account.edit',
  VIEW: 'account.view',
};

export const ADMIN_PERMISSION = 'admin';
export const HR_PERMISSION = 'hr';
export const PARTICIPANT_PERMISSION = 'participant';

export const USER_PERMISSIONS = {
  INVITE: 'user',
  EDIT: 'user.edit',
  EDIT_OTHERS: 'user.edit-others',
  ADD_TO_WORKFLOW: 'user.add-to-workflow',
  ADD_TO_JOB: 'user.add-to-job',
  ADD_TO_COMPANY: 'user.add-to-company',
};

export const COMPANY_PERMISSIONS = {
  CREATE: 'company.create',
  EDIT: 'company.edit',
  COST_VIEW: 'company.cost.view',
  MARK: 'company.mark',
  UNRESTRICTED_VIEW: 'company.unrestricted-view',
  STATUS: 'company.status',
};

export const JOB_PERMISSIONS = {
  CREATE: 'job.create',
  EDIT: 'job.edit',
  DELETE: 'job.delete',
  UNRESTRICTED_VIEW: 'job.unrestricted-view',
  STATUS: 'job.status',
};

export const WORKFLOW_PERMISSIONS = {
  CREATE: 'workflow.create',
  EDIT: 'workflow.edit',
};

export const STAGE_PERMISSIONS = {
  UNRESTRICTED_EDIT: 'stage.unrestricted-edit',
  UNRESTRICTED_VIEW: 'stage.unrestricted-view',
};

export const TASK_PERMISSIONS = {
  EDIT: 'task.edit',
};

export const CAMPAIGN_PERMISSIONS = {
  CREATE: 'campaign.create',
  EDIT: 'campaign.edit',
};

export const AD_PERMISSIONS = {
  CREATE: 'ad.create',
  EDIT: 'ad.edit',
};

export const CANDIDATE_PERMISSIONS = {
  ADD_TO_ANOTHER_JOB: 'candidate.add-to-another-job',
  DELETE: 'candidate.delete',
  EXPORT: 'candidate.export',
  MOVE: 'candidate.move',
  UPLOAD: 'candidate.upload',
  UNRESTRICTED_VIEW: 'candidate.unrestricted-view',
};

export const PAYMENT_PERMISSION = 'payment';
